export default __webpack_public_path__ + "static/media/autumn_statement_2022.6d559ca4.pdf";